import { Module } from "@nestjs/common";
import { ScheduleModule } from "@nestjs/schedule";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { skechersAddressEntity } from "./entity/skechers-address-entity";
import { SkechersCOLineEntity } from "./entity/skechers-co-line.entity";
import { skechersColorEntity } from "./entity/skechers-color-entity";
import { SkechersOrdersChildEntity } from "./entity/skechers-orders-child.entity";
import { SkechersOrdersEntity } from "./entity/skechers-orders.entity";
import { SkechersPdfInfoEntity } from "./entity/skechers-pdf.entity";
import { SkechersSizeEntity } from "./entity/skechers-size-entity";
import { AddressRepo } from "./repositories/address-repo";
import { ColorRepo } from "./repositories/color-repo";
import { SizeRepo } from "./repositories/size-repo";
import { SkechersCOLineRepository } from "./repositories/skechers-co-line.repo";
import { SkechersOrdersChildRepository } from "./repositories/skechers-orders-child.repo";
import { SkechersPdfRepository } from "./repositories/skechers-pdf-repo";
import { SkechersOrdersRepository } from "./repositories/skechers.repo";
import { SkechersController } from "./skechers.controller";
import { SkechersService } from "./skechers.service";


@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forFeature([
      SkechersOrdersEntity,
      SkechersOrdersChildEntity,
      SkechersPdfInfoEntity, skechersAddressEntity,
      skechersColorEntity,
      SkechersCOLineEntity,
      SkechersSizeEntity,
      SkechersCOLineEntity
    ])],
  controllers: [SkechersController],
  providers: [SkechersService, SkechersOrdersRepository, ApplicationExceptionHandler, SkechersOrdersChildRepository, SkechersPdfRepository, AddressRepo, ColorRepo, SizeRepo, SkechersCOLineRepository]
})
export class SkechersModule { }
